import { type Report } from "./ReportsList";

export type ReportGroup = {
  id: string;
  title: string;
  position: number;
  reports: Report[];
};

const createReportGroupsMap = (reports: Report[]): Map<string, ReportGroup> => {
  return reports.reduce((acc, report) => {
    if (!report.group) return acc;

    const groupId = report.group.id;
    const existingGroup = acc.get(groupId);

    if (existingGroup) {
      return acc.set(groupId, {
        ...existingGroup,
        reports: [...existingGroup.reports, report],
      });
    }

    return acc.set(groupId, {
      id: report.group.id,
      title: report.group.title,
      position: report.group.position,
      reports: [report],
    });
  }, new Map<string, ReportGroup>());
};

const sortReportGroups = (groups: ReportGroup[]): ReportGroup[] => {
  return groups
    .sort((a, b) => a.position - b.position)
    .map((group) => ({
      ...group,
      reports: group.reports.sort((a, b) => a.position - b.position),
    }));
};

export const groupReportsByCategory = (reports: Report[]): ReportGroup[] => {
  const reportsWithGroups = reports.filter((report) => report.group);
  const groupsMap = createReportGroupsMap(reportsWithGroups);
  const groups = Array.from(groupsMap.values());
  return sortReportGroups(groups);
};
